module.exports = __webpack_public_path__ + "static/media/noun.8aee2764.svg";